<template>
  <div class="banner">
    <!-- <img src="../../assets/img/banner1.jpg" alt=""> -->
    <el-carousel height="460px" autoplay>
      <el-carousel-item v-for="(item, index) in imgUrl" :key="index">
        <!-- <h3 class="small">{{ item.url }}</h3> -->
        <img style="width: 1920px; height: 460px;" :src="item.url" alt="" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgUrl: [
        {
          url: require("./banner1.png"),
        },
        {
          url: require("./banner2.png"),
        },
      ],
    };
  },
};
</script>
<style lang="stylus" scoped>
.banner
  width 100%
  height 460px
  // img
  //   display block
</style>
